import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export function wsUrl(roomId, token) {
  const httpUrl = new URL(`${BACKEND_URL}/api/ws/game/${roomId}`);
  const proto = httpUrl.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${httpUrl.host}${httpUrl.pathname}?token=${encodeURIComponent(token)}`;
}
